module["exports"] = [
  "צפון",
  "מזרח",
  "מערב",
  "דרום" 
];
